export default {
    "portrait": require('../assets/images/theme/default/table/dealer_button_portrait.png'),
    "landscape": require('../assets/images/theme/default/table/dealer_button_landscape.png'),
}